import * as React from "react";

const OverlayPortalContext = React.createContext<HTMLElement | null>(null);

const useOverlayPortalContainer = () => React.useContext(OverlayPortalContext);

export { OverlayPortalContext, useOverlayPortalContainer };
